import React, { useState, useEffect } from 'react';

const API = 'https://khepri.tech/api/v1';

// ─── 8 НИШ ──────────────────────────────────────────
const NICHES = {
  furniture: { name: 'Мебель', icon: '🪑' },
  services: { name: 'Услуги', icon: '🛠️' },
  it: { name: 'IT', icon: '💻' },
  trade: { name: 'Торговля', icon: '🏪' },
  construction: { name: 'Строительство', icon: '🏗️' },
  transport: { name: 'Транспорт', icon: '🚚' },
  rent: { name: 'Аренда', icon: '🏢' },
  production: { name: 'Производство', icon: '🏭' },
};

// ─── ВСТРОЕННЫЕ ШАБЛОНЫ (из открытых источников) ─────
const BUILTIN_TEMPLATES = {
  furniture: [
    {
      id: 'builtin-furniture-1',
      name: 'Договор подряда (мебель)',
      type: 'contract',
      type_name: 'ДОГОВОР ПОДРЯДА НА ИЗГОТОВЛЕНИЕ МЕБЕЛИ',
      source: 'ГАРАНТ (примерная форма)',
      blocks: [
        { id: 'preamble', title: 'Преамбула', text: '{customer}, именуемое в дальнейшем «Заказчик», и {executor}, именуемое в дальнейшем «Подрядчик», заключили настоящий Договор о нижеследующем:', fields: ['customer', 'executor'] },
        { id: 'subject', title: '1. Предмет договора', text: '1.1. Подрядчик обязуется изготовить мебель: {product}, в количестве {quantity}, по размерам {dimensions}, а Заказчик обязуется принять и оплатить.', fields: ['product', 'quantity', 'dimensions'] },
        { id: 'price', title: '2. Стоимость и порядок оплаты', text: '2.1. Стоимость работ составляет {amount} рублей.\n2.2. Оплата производится: {payment_terms}', fields: ['amount', 'payment_terms'] },
        { id: 'deadline', title: '3. Сроки выполнения работ', text: '3.1. Срок выполнения работ: до {deadline}.', fields: ['deadline'] },
        { id: 'liability', title: '4. Ответственность сторон', text: '4.1. За нарушение сроков Подрядчик уплачивает пеню 0,1% от суммы за каждый день просрочки.\n4.2. За нарушение сроков оплаты Заказчик уплачивает пеню 0,1% от суммы за каждый день просрочки.', fields: [] },
        { id: 'details', title: '5. Реквизиты сторон', text: 'Заказчик: {customer_details}\nПодрядчик: {executor_details}', fields: ['customer_details', 'executor_details'] },
      ],
    },
  ],
  services: [
    {
      id: 'builtin-services-1',
      name: 'Договор возмездного оказания услуг',
      type: 'service',
      type_name: 'ДОГОВОР ВОЗМЕЗДНОГО ОКАЗАНИЯ УСЛУГ',
      source: 'ГАРАНТ (примерная форма)',
      blocks: [
        { id: 'preamble', title: 'Преамбула', text: '{customer}, именуемое в дальнейшем «Заказчик», и {executor}, именуемое в дальнейшем «Исполнитель», заключили настоящий Договор о нижеследующем:', fields: ['customer', 'executor'] },
        { id: 'subject', title: '1. Предмет договора', text: '1.1. Исполнитель обязуется оказать следующие услуги: {service}, а Заказчик обязуется принять и оплатить.', fields: ['service'] },
        { id: 'price', title: '2. Стоимость и порядок оплаты', text: '2.1. Стоимость услуг составляет {amount} рублей.\n2.2. Оплата производится в течение {payment_days} дней после подписания акта.', fields: ['amount', 'payment_days'] },
        { id: 'deadline', title: '3. Сроки оказания услуг', text: '3.1. Услуги оказываются до {deadline}.', fields: ['deadline'] },
        { id: 'liability', title: '4. Ответственность сторон', text: '4.1. За нарушение сроков оплаты Заказчик уплачивает пеню 0,1% от суммы за каждый день просрочки.', fields: [] },
        { id: 'details', title: '5. Реквизиты сторон', text: 'Заказчик: {customer_details}\nИсполнитель: {executor_details}', fields: ['customer_details', 'executor_details'] },
      ],
    },
  ],
  it: [
    {
      id: 'builtin-it-1',
      name: 'Договор на разработку ПО',
      type: 'contract',
      type_name: 'ДОГОВОР НА РАЗРАБОТКУ ПРОГРАММНОГО ОБЕСПЕЧЕНИЯ',
      source: 'КонсультантПлюс (подборка форм)',
      blocks: [
        { id: 'preamble', title: 'Преамбула', text: '{customer}, именуемое в дальнейшем «Заказчик», и {executor}, именуемое в дальнейшем «Исполнитель», заключили настоящий Договор о нижеследующем:', fields: ['customer', 'executor'] },
        { id: 'subject', title: '1. Предмет договора', text: '1.1. Исполнитель обязуется разработать программное обеспечение: {software_name}, а Заказчик обязуется принять и оплатить.', fields: ['software_name'] },
        { id: 'price', title: '2. Стоимость и порядок оплаты', text: '2.1. Стоимость работ составляет {amount} рублей.\n2.2. Оплата производится: {payment_terms}', fields: ['amount', 'payment_terms'] },
        { id: 'deadline', title: '3. Сроки выполнения работ', text: '3.1. Срок сдачи работ: до {deadline}.', fields: ['deadline'] },
        { id: 'rights', title: '4. Права на результат', text: '4.1. Исключительные права на результат работ переходят к Заказчику после полной оплаты.', fields: [] },
        { id: 'details', title: '5. Реквизиты сторон', text: 'Заказчик: {customer_details}\nИсполнитель: {executor_details}', fields: ['customer_details', 'executor_details'] },
      ],
    },
  ],
  trade: [
    {
      id: 'builtin-trade-1',
      name: 'Договор поставки',
      type: 'supply',
      type_name: 'ДОГОВОР ПОСТАВКИ',
      source: 'ГАРАНТ (примерная форма)',
      blocks: [
        { id: 'preamble', title: 'Преамбула', text: '{supplier}, именуемое в дальнейшем «Поставщик», и {buyer}, именуемое в дальнейшем «Покупатель», заключили настоящий Договор о нижеследующем:', fields: ['supplier', 'buyer'] },
        { id: 'subject', title: '1. Предмет договора', text: '1.1. Поставщик обязуется поставить товар: {product}, в количестве {quantity}, а Покупатель обязуется принять и оплатить.', fields: ['product', 'quantity'] },
        { id: 'price', title: '2. Стоимость и порядок оплаты', text: '2.1. Стоимость товара составляет {amount} рублей.\n2.2. Оплата производится в течение {payment_days} дней с момента поставки.', fields: ['amount', 'payment_days'] },
        { id: 'delivery', title: '3. Условия поставки', text: '3.1. Поставка осуществляется в течение {delivery_days} дней с момента подписания договора.\n3.2. Условия доставки: {delivery_terms}', fields: ['delivery_days', 'delivery_terms'] },
        { id: 'details', title: '4. Реквизиты сторон', text: 'Поставщик: {supplier_details}\nПокупатель: {buyer_details}', fields: ['supplier_details', 'buyer_details'] },
      ],
    },
  ],
  construction: [
    {
      id: 'builtin-construction-1',
      name: 'Договор строительного подряда',
      type: 'contract',
      type_name: 'ДОГОВОР СТРОИТЕЛЬНОГО ПОДРЯДА',
      source: 'ГАРАНТ (примерная форма)',
      blocks: [
        { id: 'preamble', title: 'Преамбула', text: '{customer}, именуемое в дальнейшем «Заказчик», и {contractor}, именуемое в дальнейшем «Подрядчик», заключили настоящий Договор о нижеследующем:', fields: ['customer', 'contractor'] },
        { id: 'subject', title: '1. Предмет договора', text: '1.1. Подрядчик обязуется выполнить строительные работы: {work_description}, а Заказчик обязуется принять и оплатить.', fields: ['work_description'] },
        { id: 'price', title: '2. Стоимость и порядок оплаты', text: '2.1. Стоимость работ составляет {amount} рублей.\n2.2. Оплата производится поэтапно: {payment_terms}', fields: ['amount', 'payment_terms'] },
        { id: 'deadline', title: '3. Сроки выполнения работ', text: '3.1. Начало работ: {start_date}.\n3.2. Окончание работ: {end_date}.', fields: ['start_date', 'end_date'] },
        { id: 'details', title: '4. Реквизиты сторон', text: 'Заказчик: {customer_details}\nПодрядчик: {contractor_details}', fields: ['customer_details', 'contractor_details'] },
      ],
    },
  ],
  transport: [
    {
      id: 'builtin-transport-1',
      name: 'Договор перевозки груза',
      type: 'service',
      type_name: 'ДОГОВОР ПЕРЕВОЗКИ ГРУЗА',
      source: 'ГАРАНТ (Конструктор правовых документов)',
      blocks: [
        { id: 'preamble', title: 'Преамбула', text: '{customer}, именуемое в дальнейшем «Заказчик», и {carrier}, именуемое в дальнейшем «Перевозчик», заключили настоящий Договор о нижеследующем:', fields: ['customer', 'carrier'] },
        { id: 'subject', title: '1. Предмет договора', text: '1.1. Перевозчик обязуется перевезти груз: {cargo_description} по маршруту {route}, а Заказчик обязуется оплатить.', fields: ['cargo_description', 'route'] },
        { id: 'price', title: '2. Стоимость и порядок оплаты', text: '2.1. Стоимость перевозки составляет {amount} рублей.\n2.2. Оплата производится в течение {payment_days} дней.', fields: ['amount', 'payment_days'] },
        { id: 'details', title: '3. Реквизиты сторон', text: 'Заказчик: {customer_details}\nПеревозчик: {carrier_details}', fields: ['customer_details', 'carrier_details'] },
      ],
    },
  ],
  rent: [
    {
      id: 'builtin-rent-1',
      name: 'Договор аренды нежилого помещения',
      type: 'rent',
      type_name: 'ДОГОВОР АРЕНДЫ НЕЖИЛОГО ПОМЕЩЕНИЯ',
      source: 'ГАРАНТ (примерная форма)',
      blocks: [
        { id: 'preamble', title: 'Преамбула', text: '{landlord}, именуемое в дальнейшем «Арендодатель», и {tenant}, именуемое в дальнейшем «Арендатор», заключили настоящий Договор о нижеследующем:', fields: ['landlord', 'tenant'] },
        { id: 'subject', title: '1. Предмет договора', text: '1.1. Арендодатель предоставляет во временное владение и пользование помещение: {premises}, площадью {area} кв.м., по адресу {address}.', fields: ['premises', 'area', 'address'] },
        { id: 'price', title: '2. Арендная плата', text: '2.1. Арендная плата составляет {amount} рублей в месяц.\n2.2. Оплата производится до {payment_day} числа каждого месяца.', fields: ['amount', 'payment_day'] },
        { id: 'term', title: '3. Срок аренды', text: '3.1. Срок аренды: с {start_date} по {end_date}.', fields: ['start_date', 'end_date'] },
        { id: 'details', title: '4. Реквизиты сторон', text: 'Арендодатель: {landlord_details}\nАрендатор: {tenant_details}', fields: ['landlord_details', 'tenant_details'] },
      ],
    },
  ],
  production: [
    {
      id: 'builtin-production-1',
      name: 'Договор подряда (производство)',
      type: 'contract',
      type_name: 'ДОГОВОР ПОДРЯДА НА ИЗГОТОВЛЕНИЕ ПРОДУКЦИИ',
      source: 'ГАРАНТ (примерная форма)',
      blocks: [
        { id: 'preamble', title: 'Преамбула', text: '{customer}, именуемое в дальнейшем «Заказчик», и {contractor}, именуемое в дальнейшем «Подрядчик», заключили настоящий Договор о нижеследующем:', fields: ['customer', 'contractor'] },
        { id: 'subject', title: '1. Предмет договора', text: '1.1. Подрядчик обязуется изготовить продукцию: {product}, в количестве {quantity}, а Заказчик обязуется принять и оплатить.', fields: ['product', 'quantity'] },
        { id: 'price', title: '2. Стоимость и порядок оплаты', text: '2.1. Стоимость работ составляет {amount} рублей.\n2.2. Оплата производится: {payment_terms}', fields: ['amount', 'payment_terms'] },
        { id: 'deadline', title: '3. Сроки выполнения', text: '3.1. Срок изготовления: до {deadline}.', fields: ['deadline'] },
        { id: 'details', title: '4. Реквизиты сторон', text: 'Заказчик: {customer_details}\nПодрядчик: {contractor_details}', fields: ['customer_details', 'contractor_details'] },
      ],
    },
  ],
};

// ─── СЛОВАРЬ ПОЛЕЙ (для формы) ──────────────────────
const FIELD_LABELS = {
  customer: 'Заказчик', executor: 'Исполнитель', supplier: 'Поставщик', buyer: 'Покупатель',
  contractor: 'Подрядчик', carrier: 'Перевозчик', landlord: 'Арендодатель', tenant: 'Арендатор',
  product: 'Товар / продукция', quantity: 'Количество', dimensions: 'Размеры',
  service: 'Услуга', software_name: 'Название ПО', work_description: 'Описание работ',
  cargo_description: 'Описание груза', route: 'Маршрут', premises: 'Помещение',
  area: 'Площадь (кв.м.)', address: 'Адрес',
  amount: 'Сумма (₽)', payment_terms: 'Условия оплаты', payment_days: 'Срок оплаты (дней)',
  payment_day: 'День оплаты', delivery_days: 'Срок поставки (дней)', delivery_terms: 'Условия доставки',
  deadline: 'Срок исполнения', start_date: 'Дата начала', end_date: 'Дата окончания',
  customer_details: 'Реквизиты заказчика', executor_details: 'Реквизиты исполнителя',
  supplier_details: 'Реквизиты поставщика', buyer_details: 'Реквизиты покупателя',
  contractor_details: 'Реквизиты подрядчика', carrier_details: 'Реквизиты перевозчика',
  landlord_details: 'Реквизиты арендодателя', tenant_details: 'Реквизиты арендатора',
};

function Contracts() {
  const [niche, setNiche] = useState('services');
  const [mode, setMode] = useState('builtin');
  const [selectedTemplate, setSelectedTemplate] = useState(0);
  const [userTemplates, setUserTemplates] = useState([]);
  const [fieldValues, setFieldValues] = useState({});
  const [text, setText] = useState('');
  const [signatureStatus, setSignatureStatus] = useState('');
  const [sendStatus, setSendStatus] = useState('');
  const [history, setHistory] = useState([]);
  const [editingTemplate, setEditingTemplate] = useState(null);
  const token = localStorage.getItem('khepri_token');

  useEffect(() => { fetchContracts(); fetchCompany(); fetchTemplates(); }, []);

  const fetchContracts = async () => {
    try {
      const res = await fetch(API + '/contracts', { headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) { const d = await res.json(); setHistory(d.contracts || []); }
    } catch (err) { console.error(err); }
  };

  const fetchCompany = async () => {
    try {
      const res = await fetch(API + '/company', { headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) {
        const d = await res.json();
        const c = d.company || {};
        localStorage.setItem('khepri_company', JSON.stringify(c));
        setFieldValues(prev => ({
          ...prev,
          customer_details: c.inn ? `${c.name}, ИНН ${c.inn}, ${c.address}` : c.name || '',
          executor_details: c.inn ? `${c.name}, ИНН ${c.inn}, ${c.address}` : c.name || '',
        }));
      }
    } catch (err) { console.error(err); }
  };

  const fetchTemplates = async () => {
    try {
      const res = await fetch(API + '/templates', { headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) { const d = await res.json(); setUserTemplates(d.templates || []); }
    } catch (err) { console.error(err); }
  };

  const getCurrentTemplates = () => {
    if (mode === 'my') {
      return userTemplates.filter(t => t.niche === niche).map(t => {
        let blocks = [];
        try { blocks = JSON.parse(t.body_template || '[]'); } catch (e) { blocks = []; }
        return { ...t, blocks, source: 'Мой шаблон' };
      });
    }
    return BUILTIN_TEMPLATES[niche] || [];
  };

  const currentTemplates = getCurrentTemplates();
  const currentTemplate = currentTemplates[selectedTemplate];
  const allFields = currentTemplate ? Array.from(new Set(currentTemplate.blocks.flatMap(b => b.fields))) : [];

  const handleFieldChange = (key, value) => {
    setFieldValues(prev => ({ ...prev, [key]: value }));
  };

  const generate = async (e) => {
    e.preventDefault();
    if (!currentTemplate) return;

    const company = JSON.parse(localStorage.getItem('khepri_company') || '{}');
    const payload = {
      template_id: currentTemplate.id && !String(currentTemplate.id).startsWith('builtin') ? currentTemplate.id : null,
      contract_type: currentTemplate.type,
      type_name: currentTemplate.type_name || 'ДОГОВОР',
      customer: fieldValues.customer || fieldValues.supplier || fieldValues.landlord || 'ООО Заказчик',
      executor: company.name || fieldValues.executor || fieldValues.contractor || fieldValues.carrier || fieldValues.tenant || 'ООО Исполнитель',
      customer_details: fieldValues.customer_details || '',
      executor_details: fieldValues.executor_details || '',
      blocks: currentTemplate.blocks,
      fields: fieldValues,
      subject: fieldValues.service || fieldValues.product || fieldValues.work_description || 'Предмет договора',
      amount: fieldValues.amount || '500000',
      deadline: fieldValues.deadline || fieldValues.end_date || '2026-12-31',
    };

    try {
      const res = await fetch(API + '/contracts', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      setText(data.text);
      setSignatureStatus('');
      setSendStatus('');
      fetchContracts();
    } catch (err) { console.error(err); }
  };

  const saveAsMine = async () => {
    if (!currentTemplate) return;
    try {
      await fetch(API + '/templates', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({
          niche,
          name: currentTemplate.name + ' (мой)',
          contract_type: currentTemplate.type,
          blocks: currentTemplate.blocks,
        }),
      });
      fetchTemplates();
      alert('Шаблон сохранён в «Мои шаблоны». Теперь его можно редактировать.');
    } catch (err) { console.error(err); }
  };

  const saveEditedTemplate = async () => {
    if (!editingTemplate) return;
    try {
      const method = editingTemplate.id && !String(editingTemplate.id).startsWith('builtin') ? 'PUT' : 'POST';
      const url = method === 'PUT' ? API + '/templates/' + editingTemplate.id : API + '/templates';
      await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({
          niche: editingTemplate.niche,
          name: editingTemplate.name,
          contract_type: editingTemplate.type || editingTemplate.contract_type,
          blocks: editingTemplate.blocks,
        }),
      });
      setEditingTemplate(null);
      fetchTemplates();
      alert('Шаблон сохранён');
    } catch (err) { console.error(err); }
  };

  const deleteTemplate = async (id) => {
    if (!window.confirm('Удалить шаблон?')) return;
    try {
      await fetch(API + '/templates/' + id, { method: 'DELETE', headers: { Authorization: 'Bearer ' + token } });
      fetchTemplates();
    } catch (err) { console.error(err); }
  };

  const signDocument = () => {
    setSignatureStatus('pending');
    setTimeout(() => setSignatureStatus('done'), 2000);
  };

  const sendToCounterparty = () => {
    setSendStatus('sending');
    setTimeout(() => setSendStatus('sent'), 2000);
  };

  const downloadFile = () => {
    if (!text) return;
    const w = window.open('', '_blank');
    w.document.write('<html><head><title>Договор Khepri</title><style>body{font-family:Arial,sans-serif;padding:40px;line-height:1.6;white-space:pre-wrap;}</style></head><body>');
    w.document.write(text.replace(/\n/g, '<br>'));
    w.document.write('</body></html>');
    w.document.close();
    w.print();
  };

  const deleteRecord = async (id) => {
    try {
      await fetch(API + '/contracts/' + id, { method: 'DELETE', headers: { Authorization: 'Bearer ' + token } });
      fetchContracts();
    } catch (err) { console.error(err); }
  };

  return (
    <div>
      <h2 style={{ color: '#F7DE8A' }}>📄 Генератор договоров</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 16 }}>
        Выберите нишу и шаблон. Все поля можно заполнить или отредактировать.
      </p>

      {/* Ниши */}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}>
        {Object.entries(NICHES).map(([key, n]) => (
          <button key={key} type="button" onClick={() => { setNiche(key); setSelectedTemplate(0); setText(''); setFieldValues({}); }}
            style={{ padding: '10px 16px', background: niche === key ? '#F7DE8A' : '#1E293B', color: niche === key ? '#0F172A' : '#94A3B8', border: niche === key ? 'none' : '1px solid #8A6636', borderRadius: 20, cursor: 'pointer', fontSize: 13, fontWeight: niche === key ? 700 : 500, display: 'flex', alignItems: 'center', gap: 6 }}>
            <span>{n.icon}</span> {n.name}
          </button>
        ))}
      </div>

      {/* Режим */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <button type="button" onClick={() => { setMode('builtin'); setSelectedTemplate(0); }}
          style={{ padding: '8px 16px', background: mode === 'builtin' ? '#8A6636' : '#1E293B', color: mode === 'builtin' ? '#fff' : '#94A3B8', border: '1px solid #8A6636', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>
          Встроенные
        </button>
        <button type="button" onClick={() => { setMode('my'); setSelectedTemplate(0); }}
          style={{ padding: '8px 16px', background: mode === 'my' ? '#8A6636' : '#1E293B', color: mode === 'my' ? '#fff' : '#94A3B8', border: '1px solid #8A6636', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>
          Мои шаблоны ({userTemplates.filter(t => t.niche === niche).length})
        </button>
      </div>

      {/* Список шаблонов */}
      <h3 style={{ color: '#F7DE8A', fontSize: 15, marginBottom: 10 }}>
        Шаблоны для «{NICHES[niche].name}» {mode === 'builtin' ? '(встроенные)' : '(мои)'}
      </h3>
      {currentTemplates.length === 0 && (
        <p style={{ color: '#94A3B8', fontSize: 13, marginBottom: 16 }}>Нет шаблонов для этой ниши.</p>
      )}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}>
        {currentTemplates.map((tpl, i) => (
          <button key={tpl.id || i} type="button" onClick={() => { setSelectedTemplate(i); setFieldValues({}); }}
            style={{ padding: '8px 14px', background: selectedTemplate === i ? '#8A6636' : '#1E293B', color: selectedTemplate === i ? '#fff' : '#94A3B8', border: '1px solid #8A6636', borderRadius: 8, cursor: 'pointer', fontSize: 12 }}>
            {tpl.name}
          </button>
        ))}
      </div>

      {/* Действия с шаблоном */}
      {currentTemplate && (
        <div style={{ marginBottom: 16, display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
          <span style={{ color: '#94A3B8', fontSize: 12 }}>Источник: {currentTemplate.source}</span>
          <button onClick={saveAsMine} style={{ padding: '8px 16px', background: '#10B981', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
            💾 Сохранить как мой
          </button>
          {mode === 'my' && currentTemplate.id && (
            <>
              <button onClick={() => setEditingTemplate({ ...currentTemplate, niche })} style={{ padding: '8px 16px', background: '#6366F1', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
                ✏️ Редактировать
              </button>
              <button onClick={() => deleteTemplate(currentTemplate.id)} style={{ padding: '8px 16px', background: 'none', border: '1px solid #EF4444', color: '#EF4444', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>
                🗑️ Удалить
              </button>
            </>
          )}
        </div>
      )}

      {/* Динамическая форма по полям шаблона */}
      {currentTemplate && allFields.length > 0 && (
        <form onSubmit={generate} style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 12, maxWidth: 600 }}>
          <h3 style={{ color: '#F7DE8A', fontSize: 15 }}>Заполните поля договора</h3>
          {allFields.map(field => (
            <div key={field}>
              <label style={{ color: '#94A3B8', fontSize: 12, display: 'block', marginBottom: 4 }}>
                {FIELD_LABELS[field] || field}
              </label>
              <input
                value={fieldValues[field] || ''}
                onChange={e => handleFieldChange(field, e.target.value)}
                placeholder={FIELD_LABELS[field] || field}
                style={inputStyle}
              />
            </div>
          ))}
          <button type="submit" style={{ padding: 14, background: '#F7DE8A', color: '#0F172A', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 16 }}>
            📄 Сгенерировать договор
          </button>
        </form>
      )}

      {/* Результат */}
      {text && (
        <div style={{ marginTop: 20 }}>
          <div style={{ padding: 16, background: '#1E293B', borderRadius: 8, whiteSpace: 'pre-wrap', fontSize: 13, border: '1px solid #8A6636', lineHeight: 1.6 }}>
            {text}
          </div>
          <div style={{ marginTop: 12, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <button onClick={signDocument} disabled={signatureStatus !== ''} style={{ padding: '12px 24px', background: signatureStatus === 'done' ? '#10B981' : signatureStatus === 'pending' ? '#F59E0B' : '#F7DE8A', color: signatureStatus === 'done' ? '#fff' : '#0F172A', border: 'none', borderRadius: 8, cursor: signatureStatus === '' ? 'pointer' : 'default', fontWeight: 700 }}>
              {signatureStatus === 'done' ? '✅ Подписан (УКЭП)' : signatureStatus === 'pending' ? '⏳ Подписание...' : '✍️ Подписать УКЭП'}
            </button>
            <button onClick={downloadFile} style={{ padding: '12px 24px', background: '#8A6636', color: '#F8FAFC', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>
              🖨️ Скачать / Печать
            </button>
            <button onClick={sendToCounterparty} disabled={sendStatus !== ''} style={{ padding: '12px 24px', background: sendStatus === 'sent' ? '#10B981' : sendStatus === 'sending' ? '#F59E0B' : '#6366F1', color: '#fff', border: 'none', borderRadius: 8, cursor: sendStatus === '' ? 'pointer' : 'default', fontWeight: 600 }}>
              {sendStatus === 'sent' ? '✅ Отправлено' : sendStatus === 'sending' ? '⏳ Отправка...' : '📧 Отправить контрагенту'}
            </button>
          </div>
          {sendStatus === 'sent' && (
            <div style={{ marginTop: 12, padding: 12, background: 'rgba(99,102,241,0.15)', border: '1px solid #6366F1', borderRadius: 8, fontSize: 13 }}>
              <strong style={{ color: '#6366F1' }}>📨 Договор отправлен контрагенту</strong>
              <p style={{ color: '#94A3B8', marginTop: 6 }}>
                Приглашаем вашего контрагента в Khepri для удобного подписания и обмена документами. Регистрация бесплатная: <strong style={{ color: '#F7DE8A' }}>khepri.tech/invite</strong>
              </p>
            </div>
          )}
        </div>
      )}

      {/* История */}
      {history.length > 0 && (
        <div style={{ marginTop: 24 }}>
          <h3 style={{ color: '#F7DE8A', marginBottom: 12 }}>📋 История договоров</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {history.map((h) => (
              <div key={h.id} style={{ padding: 12, background: '#1E293B', borderRadius: 8, border: '1px solid #8A6636', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: '#F7DE8A' }}>{h.type_name}</div>
                  <div style={{ fontSize: 12, color: '#94A3B8', marginTop: 4 }}>{h.customer} • {h.subject} • {h.amount} ₽</div>
                </div>
                <button onClick={() => deleteRecord(h.id)} style={{ background: 'none', border: '1px solid #EF4444', color: '#EF4444', padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12 }}>
                  Удалить
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* МОДАЛЬНОЕ ОКНО РЕДАКТИРОВАНИЯ ШАБЛОНА */}
      {editingTemplate && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 16 }}>
          <div style={{ background: '#1E293B', borderRadius: 12, border: '1px solid #8A6636', maxWidth: 700, width: '100%', maxHeight: '90vh', overflowY: 'auto', padding: 24 }}>
            <h3 style={{ color: '#F7DE8A', marginBottom: 16 }}>✏️ Редактор шаблона</h3>

            <label style={{ color: '#94A3B8', fontSize: 12 }}>Название шаблона</label>
            <input
              value={editingTemplate.name}
              onChange={e => setEditingTemplate({ ...editingTemplate, name: e.target.value })}
              style={{ ...inputStyle, marginBottom: 16 }}
            />

            {editingTemplate.blocks.map((block, idx) => (
              <div key={idx} style={{ marginBottom: 16, padding: 12, background: '#0F172A', borderRadius: 8, border: '1px solid #8A6636' }}>
                <label style={{ color: '#F7DE8A', fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 6 }}>
                  Блок {idx + 1}: {block.title}
                </label>
                <textarea
                  value={block.text}
                  onChange={e => {
                    const newBlocks = [...editingTemplate.blocks];
                    newBlocks[idx] = { ...block, text: e.target.value };
                    setEditingTemplate({ ...editingTemplate, blocks: newBlocks });
                  }}
                  rows={4}
                  style={{ ...inputStyle, width: '100%', resize: 'vertical' }}
                />
                <p style={{ color: '#94A3B8', fontSize: 11, marginTop: 4 }}>
                  Поля для подстановки: {block.fields.map(f => `{${f}}`).join(', ') || 'нет'}
                </p>
              </div>
            ))}

            <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
              <button onClick={saveEditedTemplate} style={{ padding: '10px 24px', background: '#F7DE8A', color: '#0F172A', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 700 }}>
                Сохранить
              </button>
              <button onClick={() => setEditingTemplate(null)} style={{ padding: '10px 24px', background: 'transparent', color: '#94A3B8', border: '1px solid #8A6636', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>
                Отмена
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const inputStyle = {
  padding: 12,
  background: '#0F172A',
  border: '1px solid #8A6636',
  borderRadius: 8,
  color: '#F8FAFC',
  fontSize: 14,
};

export default Contracts;